/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./dx-side-dropdown-tree.component.css.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./dx-side-dropdown-tree.component";
var styles_DxSideDropdownTreeComponent = [i0.styles];
var RenderType_DxSideDropdownTreeComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_DxSideDropdownTreeComponent, data: {} });
export { RenderType_DxSideDropdownTreeComponent as RenderType_DxSideDropdownTreeComponent };
export function View_DxSideDropdownTreeComponent_0(_l) { return i1.ɵvid(0, [], null, null); }
export function View_DxSideDropdownTreeComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "dx-side-dropdown-tree", [], null, null, null, View_DxSideDropdownTreeComponent_0, RenderType_DxSideDropdownTreeComponent)), i1.ɵdid(1, 49152, null, 0, i2.DxSideDropdownTreeComponent, [], null, null)], null, null); }
var DxSideDropdownTreeComponentNgFactory = i1.ɵccf("dx-side-dropdown-tree", i2.DxSideDropdownTreeComponent, View_DxSideDropdownTreeComponent_Host_0, { menuNode: "menuNode" }, {}, []);
export { DxSideDropdownTreeComponentNgFactory as DxSideDropdownTreeComponentNgFactory };
